import PropTypes from 'prop-types';
import classes from './SectionImage.module.css';
import { parseIndex } from '../../../../utils';

const SectionImage = ({ color, imageSrc, index, name }) => (
  <div
    className={classes.imageContainer}
    style={{
      backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0) 30%, ${color} 100%), url(${process.env.PUBLIC_URL}${imageSrc})`,
      backgroundPosition: 'center',
      backgroundRepeat: 'norepeat',
      backgroundSize: 'cover',
      position: 'relative',
    }}
  >
    <div className={classes.sectionInfo}>
      <p className={classes.sectionLabel}>SECTION</p>
      <p className={classes.index}>{parseIndex(index)}</p>
      <p className={classes.name}>{name}</p>
    </div>
  </div>
);

SectionImage.propTypes = {
  color: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};

export default SectionImage;
